// import React from 'react'

// function FinancePlan() {
//   return <div>11</div>
// }

// export default FinancePlan
import '@src/assets/style/main.scss'
import EndlessList from '@src/component/endlessList'
import {AlertModal, PushConfirmModal} from '@src/component/IModal'
import {formatString} from '@src/constant'
import {goto} from '@src/route'
import CommonService from '@src/service/commonService'
import {isEmpty} from '@src/util'
import {Picker, Toast} from 'antd-mobile-v2'
import moment from 'moment'
import React from 'react'

const CaseType = [
    {value: 0, label: '未下发'},
    {value: 2, label: '待客户确认'},
    {value: 3, label: '已拒绝'},
    {value: 88, label: '已过期'},
]

const Status = [
    {value: 0, label: '处理中'},
    {value: 1, label: '已完成'},
    {value: 6, label: '已终止'},
    {value: 7, label: '已结束'},
]

export type QueryResultType = { list: Array<any>; total: number }

export type QueryType = {
    page: number
    content?: string
    status?: number
    financePlanStatus: number
}

type FinancePlanPropsType = {
    // render?: (e: any, i: number) => React.ReactNode
    action?: (params: QueryType) => QueryResultType | Promise<QueryResultType>
    hide?: boolean
}

let isRequest = false
type FinancePlanStateType = {
    page: number
    list: any[]
    total: number
    params: {
        content: string
        status?: number
        financePlanStatus: number
    }
    loading?: boolean
    visible?: boolean
    reasonVisible?: boolean
}

const queryParam = {
    id: 0,
    beforeStatus: 0,
}

let reason = ''

export default class FinancePlan extends React.Component<FinancePlanPropsType,
    FinancePlanStateType> {
    ref?: any
    containerRef?: any
    datePickerRef?: any

    constructor(props: FinancePlanPropsType) {
        super(props)
        this.state = {
            page: 0,
            list: [],
            total: 0,
            params: {
                content: '',
                financePlanStatus: -1,
            },
            visible: false,
            reasonVisible: false,
        }
    }

    async onRefresh(state?: FinancePlanStateType) {
        if (isRequest) {
            return
        }
        isRequest = true
        const {list, total, page, params} = state || this.state
        if (total && list.length >= total) {
            return
        }
        const newPage = page + 1
        const param: any = {
            ...params,
            pages: newPage,
        }
        if (isEmpty(param.content)) {
            delete param.content
        }
        const {action} = this.props
        if (!action || typeof action !== 'function') {
            return
        }
        this.setState({loading: true})
        let data = action(param)
        if (data instanceof Promise) {
            data = await data
        }
        isRequest = false
        this.setState({loading: false})
        if (data) {
            let _list: any[] = data.list || []
            const _total = data.total || 0
            _list = list.concat(_list)
            this.setState({total: _total, list: _list, page: newPage})
        } else {
            Toast.fail('数据加载失败...')
        }
    }

    componentDidMount() {
        isRequest = false
        this.onRefresh()
    }

    UNSAFE_componentWillReceiveProps(nextProps: FinancePlanPropsType) {
        if (nextProps.hide !== this.props.hide && nextProps.hide === false) {
            isRequest = false
            const {params} = this.state
            const state = {params, page: 0, list: [], total: 0}
            this.setState(state)
            this.onRefresh(state)
            this.containerRef?.querySelector('div').scrollTo({top: 0})
        }
    }

    filterItemChange(type: 'status' | 'financePlanStatus', value: any) {
        const {params} = this.state
        if (type === 'status') {
            params.status = value
        } else if (type === 'financePlanStatus') {
            params.financePlanStatus = value
        }

        const state = {params, page: 0, list: [], total: 0}
        this.setState(state)
        this.onRefresh(state)
        this.containerRef?.querySelector('div').scrollTo({top: 0})
    }

    allStatus(array: Array<{ label: string; value: any }>) {
        return [{value: -1, label: '全部'}].concat(array)
    }

    statusText(array: Array<{ label: string; value: any }>, status: any) {
        return array.find((e) => e.value == status)?.label || '全部'
    }

    // 编辑状态
    centerEditStatus(val: string) {
        CommonService.editStatus({
            loaningInfoId: queryParam.id.toString(),
            status: '6',
            reason: val,
            beforeStatus: queryParam.beforeStatus.toString(),
        }).then(() => {
            const {params} = this.state
            const state = {params, page: 0, list: [], total: 0, visible: false}
            this.setState(state)
            this.onRefresh(state)
            this.containerRef?.querySelector('div').scrollTo({top: 0})
        })
    }

    // 填写原因
    showModal(id: number, beforeStatus: number) {
        this.setState({visible: true})
        queryParam.id = id
        queryParam.beforeStatus = beforeStatus
    }

    showReason(val: string) {
        reason = val
        this.setState({reasonVisible: true})
    }

    render() {
        const {list, params, loading, total, visible, reasonVisible} = this.state
        const {hide} = this.props
        const noMore = list.length >= total

        return (
            <>
                {visible && (
                    <PushConfirmModal
                        visible={visible}
                        onOk={this.centerEditStatus.bind(this)}
                        onCancel={() => this.setState({visible: false})}
                    />
                )}
                {reasonVisible && (
                    <AlertModal
                        visible={reasonVisible}
                        title="原因"
                        content={<div style={{textAlign: 'center'}}>{reason}</div>}
                        onOk={() => this.setState({reasonVisible: false})}
                    />
                )}

                <div className="m-tab" style={{display: hide ? 'none' : 'flex'}}>
                    <div className="m-query-bar">
                        {/* 手机号 */}
                        <div className="m-row">
                            <input
                                className="input"
                                value={params.content}
                                placeholder="请输入姓名/手机号搜索"
                                onChange={(e) => {
                                    const value = e.target.value
                                    if (isEmpty(value)) {
                                        params.content = ''
                                    } else {
                                        params.content = value
                                    }
                                    this.setState({params})
                                }}
                            />
                            <div
                                className="btn-search"
                                onClick={() => {
                                    const params = this.state.params
                                    const state = {params, page: 0, list: [], total: 0}
                                    this.onRefresh(state)
                                }}
                            >
                                搜索
                            </div>
                        </div>
                        {/* 分类选择 */}
                        <div className="m-row">
                            <div className="m-filter-item">
                                <span className="btn-selector-label">状态:</span>
                                <Picker
                                    data={this.allStatus(CaseType)}
                                    value={
                                        params.financePlanStatus || params.financePlanStatus === 0
                                            ? [params.financePlanStatus]
                                            : undefined
                                    }
                                    extra="全部"
                                    cols={1}
                                    onChange={(e) => {
                                        let statusValue: any
                                        if (e && e.length > 0) {
                                            const value: any = e[0]
                                            // if (value === -1) {
                                            //   statusValue = undefined
                                            // } else {
                                            //   statusValue = value
                                            // }
                                            statusValue = value
                                        } else {
                                            statusValue = undefined
                                        }
                                        this.filterItemChange('financePlanStatus', statusValue)
                                    }}
                                >
                  <span className="btn-selector-value">
                    {this.statusText(CaseType, params.financePlanStatus)}
                  </span>
                                </Picker>
                            </div>
                        </div>
                    </div>
                    {/* list body */}
                    <div className="m-body" ref={this.containerRef}>
                        <EndlessList
                            onTouchBottom={this.onRefresh.bind(this)}
                            loading={loading}
                            noMore={noMore}
                        >
                            <div className="m-list">
                                {list.map((e, i) => (
                                    <RenderItem
                                        data={e}
                                        key={i}
                                        show={this.showModal.bind(this)}
                                        showReason={this.showReason.bind(this)}
                                    />
                                ))}
                            </div>
                        </EndlessList>
                    </div>
                </div>
            </>
        )
    }
}

export function RenderItem(props: {
    data: any
    show: (id: number, beforeStatus: number) => void
    showReason: (val: string) => void
}) {
    const {data, show, showReason} = props

    const action = () => {
        if (data.status === 0) {
            // show(data.id, data.status)
        } else {
            CommonService.getPlanDetail({loaningInfoId: data.loaningInfoId}).then(
                (res: any) => {
                    showReason(res.rejectReason)
                }
            )
        }
    }

    const toDetail = () => {
        if (data.financePlanStatus === 0) {
            goto('/plan-detail-edit', {
                userName: data.insuredName,
                id: data.loaningInfoId,
                status: data.financePlanStatus,
                source: data.source,
                rate: data.finalRate,
                earnestmoneypercent: data.earnestMoneyPercent,
                firstpaidpercent: data.firstPaidPercent,
                experiment: data.experiment,
                price:data.netPrice,
                stage:data.stage
            })
            return
        }
        goto('/plan-detail', {
            userName: data.insuredName,
			id: data.loaningInfoId,
			status: data.financePlanStatus,
			source: data.source,
            experiment: data.experiment,
			rate: isEmpty(data.finalRate) || '0',
			earnestmoneypercent: isEmpty(data.earnestMoneyPercent) || '0',
			firstpaidpercent: data.firstPaidPercent,
            price:data.netPrice
        })
    }

    return (
        <div className="m-list-item">
            <div className="row">
                <div className="label name">{data.insuredName}</div>
                <div className="value">{data.mobile}</div>
            </div>
            <div className="row">
                <div className="label" style={{whiteSpace: 'nowrap'}}>
                    复审通过时间
                </div>
                <div className="value">
                    {data.loanPassTime && moment(data.loanPassTime).format(formatString)}
                </div>
            </div>
            <div className="row">
                <div className="label">申请车型</div>
                <div className="value">
                    {data.brandName}+{data.vehicleName}
                </div>
            </div>
            <div className="row">
                <div className="label">跟单销售</div>
                <div className="value">{data.saleName}</div>
            </div>
            <div className="row">
                <div className="label">状态</div>
                <div className="value">
                    {
                        CaseType.find((item) => item.value === data.financePlanStatus)
                            ?.label
                    }
                </div>
                <div style={{paddingLeft: 6, color: '#6291DF'}} onClick={toDetail}>
                    {[0].includes(data.financePlanStatus) && '确认金融方案'}
                    {data.financePlanStatus !== 0 && '查看金融方案'}
                    {/* {[1, 3].includes(data.financePlanStatus) && '查看原因'} */}
                    {`>>`}
                </div>
            </div>
            {data.uptime && (
                <div className="row">
                    <div className="label">更新时间</div>
                    <div className="value">
                        {moment(data.uptime).format(formatString)}
                    </div>
                </div>
            )}
        </div>
    )
}
